import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { GameChallenges } from "../../util/Requests";
import {
  CELL_SX,
  HEAD_SX,
  ROW_LABEL_SX,
  ZEBRA_SX,
} from "../PlayerBlobPage/sections";

/**
 * Coach's challenges per team: won / used ("1/2"), "—" for none. Both teams
 * always get a row (the endpoint only returns teams with challenge events),
 * ours first. `status` distinguishes a failed lookup from a quiet game.
 */
export default function ChallengesTable({
  challenges,
  teams,
  status = "ok",
  inline = false,
}: {
  challenges?: GameChallenges;
  /** Our abbreviation first, then the opponent */
  teams: string[];
  status?: "loading" | "ok" | "error";
  /** One line ("POR — · PHX 1/2") for a section head's note slot */
  inline?: boolean;
}) {
  const names = [
    ...teams,
    ...Object.keys(challenges ?? {}).filter((t) => !teams.includes(t)),
  ];
  const text = (team: string) => {
    if (status === "error") return "unavailable";
    if (status === "loading") return "…";
    const c = challenges?.[team];
    const used = c ? c.stands + c.overturned + c.support : 0;
    return used ? `${c!.overturned}/${used}` : "—";
  };
  if (inline) {
    return (
      <span className="ChallengesTable chl">
        <span className="k">Challenges</span>
        {names.map((team) => (
          <span key={team}>
            <b>{team}</b> {text(team)}
          </span>
        ))}
      </span>
    );
  }
  return (
    <Table size="small" className="ChallengesTable" sx={ZEBRA_SX}>
      <TableHead>
        <TableRow>
          <TableCell sx={{ ...HEAD_SX, textAlign: "left" }} />
          <TableCell sx={HEAD_SX}>Challenges</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {names.map((team) => (
          <TableRow key={team}>
            <TableCell sx={ROW_LABEL_SX}>{team}</TableCell>
            <TableCell sx={CELL_SX}>{text(team)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
